function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  x: 2.5,
  y: 2.5,
  width: 146.26,
  height: 93.17,
  rx: 16.03,
  fill: "none",
  stroke: "#0471b8",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0471b8",
  d: "M2.5 57.76h146.26v15.78H2.5z"
})));

function SvgCreditcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 98,
    viewBox: "0 0 151.26 98.17"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUxcHgiIGhlaWdodD0iOThweCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTUxLjI2IDk4LjE3Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6IzA0NzFiODtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6NXB4O30uY2xzLTJ7ZmlsbDojMDQ3MWI4O308L3N0eWxlPjwvZGVmcz48dGl0bGU+QXNzZXQgMTwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjIuNSIgeT0iMi41IiB3aWR0aD0iMTQ2LjI2IiBoZWlnaHQ9IjkzLjE3IiByeD0iMTYuMDMiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjIuNSIgeT0iNTcuNzYiIHdpZHRoPSIxNDYuMjYiIGhlaWdodD0iMTUuNzgiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgCreditcard as ReactComponent };